import { memo } from "react";
import { IoChatbubbles } from "react-icons/io5";

import HeaderIconButton from "@/components/Core/HeaderIconButton";
import { useChatRoomGameContext, useTranslate } from "@/hooks";

const Message = () => {
  const t = useTranslate();
  const { toggle, open } = useChatRoomGameContext();

  return (
    <HeaderIconButton
      data-screenshot="toggle-mode"
      label={t("header.chat")}
      // Lit while the chat is open: the button is how it is closed again.
      active={open}
      aria-pressed={open}
      onClick={toggle}
    >
      <IoChatbubbles aria-hidden />
    </HeaderIconButton>
  );
};

export default memo(Message);
